import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Navigate, Outlet } from '@tanstack/react-router'
import { analytics, ErrorPage, MaintenancePage } from 'merchant-components'
import { decideEnabled } from 'merchant-api/vendor/optimizely'
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

export interface RootRouteContext {
  queryClient: QueryClient;
  applicationId?: string;
}

const maintenanceFlagKey = 'ece_maintenance_page_enabled';

const getIsMaintenanceEnabled = async () => {
  return decideEnabled(maintenanceFlagKey, {}, analytics);
};

const RootComponent = () => {
  const { data: isMaintenanceEnabled = false } = useQuery({
    queryKey: ['featureFlag', maintenanceFlagKey],
    queryFn: getIsMaintenanceEnabled,
    staleTime: 1000 * 60,
    throwOnError: false,
  });

  useEffect(() => {
    if (isMaintenanceEnabled) {
      analytics.track('Maintenance Page Turned On', {
        feature: maintenanceFlagKey,
        timestamp: new Date().toISOString(),
      });
    }
  }, [isMaintenanceEnabled]);

  if (isMaintenanceEnabled) return <MaintenancePage />;
  return <Outlet />;
};

export const Route = createRootRouteWithContext<RootRouteContext>()({
  component: RootComponent,
  errorComponent: (error) => (
    <div className="mt-5">
      {ErrorPage(error)}
    </div>
  ),
  notFoundComponent: () => <Navigate to='/'/>,
});
